import { TranslateService } from "@ngstack/translate";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDialog,
  MatSelectChange
} from "@angular/material";

import { IPlacementTimeSheet } from "src/app/interfaces/placementTimeSheet";
import { TimeSheetEntryComponent } from "../time-sheet-entry/time-sheet-entry.component";
import { PlacementTiemSheetService } from "src/app/services/http/business/placement/placement-tiem-sheet.service";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { ErrorsService } from "src/app/services/common/errors.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { CIDService } from "src/app/services/common/cid.service";
import { BIDService } from "src/app/services/common/bid.service";
import { BranchService } from "src/app/services/http/business/branch/branch.service";
import { IBranch } from "src/app/interfaces/branch";
import { HttpHeaders } from "@angular/common/http";

@Component({
  selector: "app-time-sheet-list",
  templateUrl: "./time-sheet-list.component.html",
  styleUrls: ["./time-sheet-list.component.css"]
})
export class TimeSheetListComponent implements OnInit {
  isOwner: boolean;
  pageSize: number;
  pageIndex: number;
  companyList: ICompany;
  companySelected: String;
  branchList: IBranch;
  displayedColumns: string[] = [
    this.translate.get("label.branch"),
    this.translate.get("label.placementType"),
    this.translate.get("numberOf", {
      name: this.translate.get("label.teachers")
    }),
    this.translate.get("label.date"),
    this.translate.get("label.startTime"),
    this.translate.get("label.endTime"),
    this.translate.get("label.deadlineTime"),
    "function"
  ];
  dataSource = new MatTableDataSource<IPlacementTimeSheet>();

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private dialog: MatDialog,
    private cidService: CIDService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private companyService: CompanyService,
    private branchService: BranchService,
    private bidService: BIDService,
    private holdingService: HoldingService,
    private placementTimeSeetService: PlacementTiemSheetService
  ) { }

  ngOnInit() {
    this.checkOwner();
    // this.companySelected = this.cidService.getCID();
    this.dataSource.paginator = this.paginator;
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      this.getlist();
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  // setCid(e: MatSelect) {
  //   this.cidService.setCID(e.value);
  //   this.getlist();
  // }

  loadBranch(e: any) {
    if (this.isOwner) {
      this.cidService.setCID(e);
      this.bidService.setBID("");
    }
    this.paginator.length = 0;
    this.getBranchList(e);
  }

  loadDataTable(e: MatSelectChange) {
    this.dataSource = null;
    if (this.isOwner)
      this.bidService.setBID(e.value);
    this.getlist();
  }

  getlist() {
    this.placementTimeSeetService.list().subscribe(res => {
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;
      this.paginator.pageIndex = 0;
      this.paginator.pageSize = 10;
    });
  }

  paginatorEvent(event) {
    this.placementTimeSeetService
      .list(event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex + 1;
      });
  }



  getBranchList(company) {
    var headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        company
      );
    this.branchService.listByCompanyHeader(0, 0, headers).subscribe(res => {
      this.branchList = res.DataList;
    });
  }

  add() {
    this.dialog
      .open(TimeSheetEntryComponent)
      .afterClosed()
      .subscribe(() => {
        this.placementTimeSeetService
          .list(this.pageIndex, this.pageSize)
          .subscribe(re => {
            this.dataSource = re.DataList;
            this.paginator.length = re.Total;
          });
      });
  }

  edit(data: IPlacementTimeSheet) {
    this.dialog
      .open(TimeSheetEntryComponent, {
        data: data
      })
      .afterClosed()
      .subscribe(() => {
        this.placementTimeSeetService
          .list(this.pageIndex, this.pageSize)
          .subscribe(re => {
            this.dataSource = re.DataList;
            this.paginator.length = re.Total;
          });
      });
  }

  delete(data: IPlacementTimeSheet) {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.cancel", {
        name: this.translate.get("label.placementTimeSheet")
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };
    this.dialog
      .open(ConfirmComponent, {
        width: "250px",
        data: confirm
      })
      .afterClosed()
      .subscribe(
        res => {
          if (res) {
            this.placementTimeSeetService.delete(data).subscribe(() => {
              this.placementTimeSeetService
                .list(this.pageIndex, this.pageSize)
                .subscribe(re => {
                  this.dataSource = re.DataList;
                  this.paginator.length = re.Total;
                });
            });
          }
        },
        err => {
          this.errorService.recordHasBennUsed(err);
        }
      );
  }
}
